export default __webpack_public_path__ + "e7d4f4682e83c970a79775eae78e7dd1.png";